/*eslint-disable*/
import React, { useState, useEffect } from "react";
import Axios from 'axios';
import ApiConfig from "_config/ApiConfig";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import FormControl from "@material-ui/core/FormControl";
//import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

import DefaultInput from "components/ToggleVisibility/DefaultInput.js";

import ToggleVisibilityAddInput from "components/ToggleVisibility/ToggleVisibilityAddInput.js";

import profilePageStyle from "assets/jss/material-kit-pro-react/views/profilePageStyle.js";

const useStyles = makeStyles(profilePageStyle);

export default function SectionModelePage() {

  const getModeleProduct = async (ids) => {
     try {
      Axios.defaults.withCredentials = true;
      Axios.get(`${ApiConfig.baseUrl}/Controls/GetModele.php`)
        .then(res => {
          setModeleProduct(res.data.modeleproductdata);
          return;
        })
    } catch (error) { throw error; } 
  };

  const [isModeleProduct, setModeleProduct] = useState([]);
  const [modeleSelect, setModeleSelect] = useState([]);

  sessionStorage.setItem("getModeleSelect", modeleSelect);
  const classes = useStyles();
  useEffect(() => {
    getModeleProduct();
  }, []);

  return (
      <div className={classNames(classes.main, classes.mainRaised_)}>
        <div className={classes.container_}>
        <label className={classes.title}>MODELE </label><ToggleVisibilityAddInput>
          <DefaultInput 
           valueString={'Modele'}
           />
        </ToggleVisibilityAddInput>
          <FormControl
            fullWidth
            className={classes.selectFormControl}
          >
            <Select
              MenuProps={{
                className: classes.selectMenu
              }}
              classes={{
                select: classes.select
              }}
              value={modeleSelect}
              onChange={event => setModeleSelect(event.target.value)}
              inputProps={{
                name: "modeleSelect",
                id: "modeleSelect"
              }}
            >
              {isModeleProduct.map((item) => (
                <MenuItem key={item.id_mod}
                  classes={{
                    root: classes.selectMenuItem,
                    selected: classes.selectMenuItemSelected
                  }}
                  value={item.id_mod}
                >
                  {item.design_mod}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>
  );
}
